import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { GlobalDataProvider } from "hooks/globalData";
import { queryClient } from "index";
import en from "intl/en";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { IntlProvider } from "react-intl";
import { QueryClientProvider } from "react-query";

type AppDependenciesProviderProps = {
  children: React.ReactNode;
};

export const AppDependenciesProvider = ({
  children,
}: AppDependenciesProviderProps) => {
  const onIntlError = (err: any) => {
    console.log(err);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale="en" messages={en} onError={onIntlError}>
          <GlobalDataProvider>
            <DndProvider backend={HTML5Backend}>{children}</DndProvider>
          </GlobalDataProvider>
        </IntlProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  );
};
